/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_TitleInputs */

const vi_weighing_title = /** @type {(inputs: Weighing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cân chè tươi`)
};

/**

* @param {Weighing_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_title = /** @type {((inputs?: Weighing_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_title(inputs)
});